import React from "react";
import "./Form.css";
import img from "../../images/arrow.svg";
import { Table } from "react-bootstrap";
import { data } from "../../data";

const Form = () => {
  return (
    <div className="container">
      <div className="heading-container">
        <hr className="line" />
        <h1>Axis Mobile Checksum</h1>
      </div>
      <div className="form-container">
        <div className="details-container">
          <div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Platform</th>
                  <th>App Version</th>
                  <th>App Checksum</th>
                </tr>
              </thead>
              <tbody>
                {data.map((entry) => {
                  return (
                    <tr key={`${entry.platform}${entry.version}`}>
                      <td>{entry.platform === "AN" ? "Android" : "iOS"}</td>
                      <td>{entry.version}</td>
                      <td>{entry.checksum}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="subtitle-container">
            <p>
              A checksum is a value used to verify the integrity of a file or a
              data transfer. In other words, it is a sum that checks the
              integrity of data/file ; this assures the receiver that the
              files/data has not been compromised.
            </p>
          </div>
          <div className="list-container">
            <p>Features of Checksum Validation</p>
            <ul style={{ listStyleImage: `url(${img})` }}>
              <li className="list-item">
                To verify that the content in the file is of integral nature
              </li>
              <li className="list-item">
                To confirm that the file has neither been altered by
                unauthorized third party,nor been damaged during the transfer
                process across the internet
              </li>
              <li className="list-item">To act as signature of the file</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
